import React from 'react';
import { Outlet } from 'react-router-dom';

const EmptyLayout = props => (<><Outlet/></>);

export default EmptyLayout;